import { render, staticRenderFns } from "./TianjiaPlanThree.vue?vue&type=template&id=526fd076&scoped=true&"
import script from "./TianjiaPlanThree.vue?vue&type=script&lang=js&"
export * from "./TianjiaPlanThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526fd076",
  null
  
)

export default component.exports